import { render } from "./DataForm.vue?vue&type=template&id=3018a0f4&scoped=true"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"

import "./DataForm.vue?vue&type=style&index=0&id=3018a0f4&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3018a0f4"]])

export default __exports__